
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createAiDuoWorkflow"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ProjectID"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"namespaceId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"NamespaceID"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"goal"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workflowDefinition"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"agentPrivileges"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preApprovedAgentPrivileges"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"allowAgentToRequestUser"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"aiCatalogItemVersionId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AiCatalogItemVersionID"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"webSearchEnabled"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aiDuoWorkflowCreate"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"projectId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"projectId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"namespaceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"namespaceId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"environment"},"value":{"kind":"EnumValue","value":"WEB"}},{"kind":"ObjectField","name":{"kind":"Name","value":"goal"},"value":{"kind":"Variable","name":{"kind":"Name","value":"goal"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"workflowDefinition"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workflowDefinition"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"agentPrivileges"},"value":{"kind":"Variable","name":{"kind":"Name","value":"agentPrivileges"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"preApprovedAgentPrivileges"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preApprovedAgentPrivileges"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"allowAgentToRequestUser"},"value":{"kind":"Variable","name":{"kind":"Name","value":"allowAgentToRequestUser"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"aiCatalogItemVersionId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"aiCatalogItemVersionId"}}},{"kind":"ObjectField","name":{"kind":"Name","value":"webSearchEnabled"},"value":{"kind":"Variable","name":{"kind":"Name","value":"webSearchEnabled"}}}]}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"workflow"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":810}};
    doc.loc.source = {"body":"mutation createAiDuoWorkflow(\n  $projectId: ProjectID\n  $namespaceId: NamespaceID\n  $goal: String!\n  $workflowDefinition: String!\n  $agentPrivileges: [Int!]\n  $preApprovedAgentPrivileges: [Int!]\n  $allowAgentToRequestUser: Boolean\n  $aiCatalogItemVersionId: AiCatalogItemVersionID\n  $webSearchEnabled: Boolean\n) {\n  aiDuoWorkflowCreate(\n    input: {\n      projectId: $projectId\n      namespaceId: $namespaceId\n      environment: WEB\n      goal: $goal\n      workflowDefinition: $workflowDefinition\n      agentPrivileges: $agentPrivileges\n      preApprovedAgentPrivileges: $preApprovedAgentPrivileges\n      allowAgentToRequestUser: $allowAgentToRequestUser\n      aiCatalogItemVersionId: $aiCatalogItemVersionId\n      webSearchEnabled: $webSearchEnabled\n    }\n  ) {\n    workflow {\n      id\n    }\n    errors\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["createAiDuoWorkflow"] = oneQuery(doc, "createAiDuoWorkflow");
        
